import { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  es: {
    // Navbar
    'nav.properties': 'Propiedades',
    'nav.login': 'Iniciar Sesión',
    'nav.dashboard': 'Panel Admin',
    'nav.logout': 'Cerrar sesión',
    'nav.favorites': 'Mis Favoritos',
    'nav.messages': 'Mensajes',
    'nav.verification': 'Verificación',
    'nav.back': 'Volver',
    'map.searchPlaceholder': 'Buscar propiedad, ciudad o código...',
    'map.filters': 'Filtros',
    'map.properties': 'propiedades',
    'map.country': 'Pais',
    'map.city': 'Ciudad',
    'map.guests': 'Huéspedes',
    'map.bedrooms': 'Dormitorios',
    'map.all': 'Todos',
    'map.any': 'Cualquiera',
    'map.clearFilters': 'Limpiar',
    'map.viewProperty': 'Ver',
    'landing.viewMap': 'Explorar Mapa',
    'properties.viewMap': 'Ver Mapa',
    // Landing Hero
    'landing.hero.subtitle': 'Alojamientos en Paraguay, Argentina y Brasil',
    'landing.hero.title': 'Descubre tu próximo destino',
    'landing.hero.desc': 'Mas de {properties} propiedades unicas en {cities} ciudades de Paraguay. Desde hoteles boutique hasta cabañas rodeadas de naturaleza.',
    'landing.search.placeholder': 'A donde vas?',
    'landing.search.button': 'Buscar',
    // Landing Features
    'landing.why.label': 'Por que elegirnos',
    'landing.why.title': 'La mejor experiencia de hospedaje',
    'landing.why.properties': '+{count} Propiedades',
    'landing.why.properties.desc': 'Amplia variedad de alojamientos verificados en Paraguay, Argentina y Brasil',
    'landing.why.payments': 'Pagos Múltimoneda',
    'landing.why.payments.desc': 'Acepta USD, PYG, ARS, BRL y mas con tipos de cambio actualizados',
    'landing.why.security': 'Reservas Seguras',
    'landing.why.security.desc': 'Proceso de reserva confiable con confirmación instantanea',
    'landing.why.support': 'Atencion rapida',
    'landing.why.support.desc': 'Te ayudamos a encontrar la opcion ideal para tu viaje, con acompanamiento personalizado.',
    'landing.why.protection': 'Reserva protegida',
    'landing.why.protection.desc': 'Pago seguro, respaldo ante inconvenientes y mayor tranquilidad durante todo el proceso.',
    // Landing Destinations
    'landing.destinations': 'Destinos',
    'landing.destinations.title': 'Explora nuestros paises',
    'landing.destinations.explore': 'Explorar',
    'landing.destinations.properties': 'propiedades',
    // Landing Featured
    'landing.featured': 'Destacados',
    'landing.featured.title': 'Propiedades populares',
    'landing.featured.viewAll': 'Ver todas',
    'landing.featured.viewAllMobile': 'Ver todas las propiedades',
    // Landing Testimonials
    'landing.testimonials': 'Testimonios',
    'landing.testimonials.title': 'Lo que dicen nuestros huéspedes',
    // Landing CTA
    'landing.cta.title': 'Tienes una propiedad?',
    'landing.cta.subtitle': 'Unete a nuestra plataforma y llega a miles de viajeros. Gestióna tus reservas, sincroniza con Airbnb y recibe pagos en multiples monedas.',
    'landing.cta.button': 'Registrar mi propiedad',
    'landing.instagram.follow': 'Seguinos en',
    'landing.instagram.view': 'Ver Instagram',
    // Landing Footer
    'landing.footer.desc': 'La plataforma lider de alojamientos en Paraguay, Brasil y Argentina con gestión de pagos múltimoneda y sincronizacion con Airbnb.',
    'landing.footer.links': 'Enlaces',
    'landing.footer.aboutUs': 'Sobre nosotros',
    'landing.footer.contact': 'Contacto',
    'landing.footer.legal': 'Legal',
    'landing.footer.terms': 'Terminos',
    'landing.footer.privacy': 'Privacidad',
    'landing.footer.rights': '2026 Estadía 365. Todos los derechos reservados.',
    // Landing coupon banner
    'landing.coupon.use': 'Usa',
    'landing.coupon.get': 'y obten',
    'landing.coupon.off': 'de descuento',
    // Common property
    'common.guests': 'huéspedes',
    'common.perNight': '/ noche',
    'common.loading': 'Cargando...',
    'common.error': 'Error',
    'common.save': 'Guardar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.close': 'Cerrar',
    'common.confirm': 'Confirmar',
    'common.added': 'Agregado a favoritos',
    'common.removed': 'Eliminado de favoritos',
    'common.loginRequired': 'Inicia sesión para continuar',
    // Properties Page
    'properties.title': 'Propiedades',
    'properties.subtitle': '{count} alojamientos disponibles',
    'properties.search.placeholder': 'Buscar por nombre, código...',
    'properties.search.button': 'Buscar',
    'properties.filter.clear': 'Limpiar',
    'properties.filter.country': 'Pais',
    'properties.filter.city': 'Ciudad',
    'properties.filter.type': 'Tipo',
    'properties.filter.priceMin': 'Precio min',
    'properties.filter.priceMax': 'Precio max',
    'properties.filter.bedrooms': 'Dormitorios',
    'properties.filter.guests': 'Huéspedes',
    'properties.filter.sortBy': 'Ordenar por',
    'properties.filter.all': 'Todos',
    'properties.filter.allCities': 'Todas',
    'properties.filter.mostRecent': 'Mas recientes',
    'properties.filter.priceAsc': 'Precio: menor a mayor',
    'properties.filter.priceDesc': 'Precio: mayor a menor',
    'properties.filter.moreGuests': 'Mas huéspedes',
    'properties.noResults': 'No se encontraron propiedades',
    'properties.noResults.desc': 'Intenta con otros filtros',
    'properties.instantBooking': 'Reserva Inmediata',
    // Property types
    'type.Hotel': 'Hotel',
    'type.Apartment': 'Apartamento',
    'type.House': 'Casa',
    'type.Cabin': 'Cabaña',
    // Property Detail
    'detail.back': 'Volver',
    'detail.guests': 'Huéspedes',
    'detail.bedrooms': 'Dormitorios',
    'detail.beds': 'Camas',
    'detail.bathrooms': 'Baños',
    'detail.description': 'Descripción',
    'detail.amenities': 'Amenidades',
    'detail.location': 'Ubicación',
    'detail.viewMaps': 'Ver en Google Maps',
    'detail.cancellation': 'Política de Cancelación',
    'detail.cancellation.flexible': 'Flexible',
    'detail.cancellation.flexible.desc': 'Reembolso total si cancelas hasta 24 horas antes del check-in.',
    'detail.cancellation.moderate': 'Moderada',
    'detail.cancellation.moderate.desc': 'Reembolso total si cancelas hasta 5 dias antes del check-in.',
    'detail.cancellation.strict': 'Estricta',
    'detail.cancellation.strict.desc': 'Reembolso del 50% si cancelas hasta 7 dias antes del check-in. Sin reembolso despues.',
    'detail.cancellation.non_refundable': 'No reembolsable',
    'detail.cancellation.non_refundable.desc': 'Esta reserva no es reembolsable una vez confirmada.',
    'detail.checkin': 'Check-in / Check-out',
    'detail.checkinTime': 'Check-in',
    'detail.checkinFrom': 'A partir de las',
    'detail.checkoutTime': 'Check-out',
    'detail.checkoutBefore': 'Antes de las',
    'detail.accessCode': 'Código de acceso',
    'detail.checkinInstructions': 'Instrucciones de llegada',
    'detail.checkoutInstructions': 'Instrucciones de salida',
    'detail.houseRules': 'Reglas de la Casa',
    'detail.policies': 'Políticas de Huéspedes',
    'detail.petsAllowed': 'Mascotas',
    'detail.childrenAllowed': 'Niños',
    'detail.infantsAllowed': 'Bebés',
    'detail.smokingAllowed': 'Fumar',
    'detail.minNights': 'Mínimo',
    'detail.maxNights': 'Máximo',
    'detail.reviews': 'Reseñas',
    'detail.writeReview': 'Escribir Reseña',
    'detail.noReviews': 'Aun no hay reseñas para esta propiedad',
    'detail.beFirst': 'Se el primero en dejar una!',
    'detail.ownerResponse': 'Respuesta del propietario',
    'detail.respond': 'Responder',
    'detail.cancel': 'Cancelar',
    'detail.booking': 'Reservar',
    'detail.selectDates': 'Selecciona tus fechas',
    'detail.checkIn': 'Check-in',
    'detail.checkOut': 'Check-out',
    'detail.night': 'noche',
    'detail.nights': 'noches',
    'detail.total': 'Total',
    'detail.cleaning': 'Limpieza',
    'detail.adults': 'Adultos',
    'detail.age13plus': '13 años o más',
    'detail.children': 'Niños',
    'detail.age2to12': '2 a 12 años',
    'detail.infants': 'Bebés',
    'detail.under2': 'Menos de 2 años',
    'detail.maxGuests': 'Máximo',
    'detail.guestsLabel': 'huéspedes',
    'detail.infantsNotCount': 'los bebés no cuentan',
    'detail.deposit': 'Total a pagar',
    'detail.depositFinal': 'Total final',
    'detail.payDeposit': 'Pagar Deposito',
    'detail.processing': 'Procesando...',
    'detail.viewAirbnb': 'Ver en Airbnb',
    'detail.contactOwner': 'Contactar al propietario',
    'detail.adminContact': 'Contacto del administrador',
    'detail.whatsapp': 'WhatsApp',
    'detail.notAvailable': 'No disponible',
    'detail.includesAirbnb': '(Incluye Airbnb)',
    'detail.coupon': 'Cupón de descuento',
    'detail.couponPlaceholder': 'Código de cupón',
    'detail.applyCoupon': 'Aplicar',
    'detail.couponApplied': 'Cupón aplicado',
    'detail.discount': 'Descuento',
    'detail.depositAfterDiscount': 'Total con descuento',
    // Review categories
    'review.title': 'Escribir Reseña',
    'review.overall': 'Calificacion General',
    'review.categories': 'Categorias',
    'review.cleanliness': 'Limpieza',
    'review.location': 'Ubicación',
    'review.service': 'Servicio',
    'review.value': 'Relacion Calidad-Precio',
    'review.amenities': 'Amenidades',
    'review.comment': 'Comentario',
    'review.commentPlaceholder': 'Comparte tu experiencia... (mínimo 10 caracteres)',
    'review.photos': 'Fotos (opcional)',
    'review.photosCount': '{count}/5 fotos',
    'review.addPhoto': 'Agregar',
    'review.publish': 'Publicar Reseña',
    'review.publishing': 'Publicando...',
    // Payment Info
    'payment.bankTransfer': 'Transferencia Bancaria',
    'payment.howToPay': 'Como pagar por transferencia',
    'payment.scanQR': 'Escanea el QR o usa los datos bancarios',
    'payment.alias': 'Alias',
    'payment.copied': 'Copiado!',
    // Wishlist
    'wishlist.title': 'Mis Favoritos',
    'wishlist.count': '{count} propiedades',
    'wishlist.empty.title': 'Tu lista de favoritos esta vacia',
    'wishlist.empty.desc': 'Explora propiedades y guarda las que mas te gusten',
    'wishlist.empty.explore': 'Explorar propiedades',
    // Sidebar / Dashboard
    'sidebar.dashboard': 'Dashboard',
    'sidebar.properties': 'Propiedades',
    'sidebar.favorites': 'Favoritos',
    'sidebar.reservations': 'Reservas',
    'sidebar.calendar': 'Calendario',
    'sidebar.chat': 'Chat',
    'sidebar.reports': 'Reportes',
    'sidebar.settings': 'Configuración',
    'sidebar.users': 'Usuarios',
    'sidebar.coupons': 'Cupónes',
    // Coupons admin
    'coupons.title': 'Cupónes',
    'coupons.create': 'Crear Cupón',
    'coupons.active': 'Activo',
    'coupons.inactive': 'Inactivo',
    'coupons.used': 'Usos',
    'coupons.code': 'Código',
    'coupons.type': 'Tipo',
    'coupons.percentage': 'Porcentaje',
    'coupons.fixed': 'Monto fijo',
    'coupons.value': 'Valor',
    'coupons.maxUses': 'Usos máximos',
    'coupons.minAmount': 'Monto mínimo',
    'coupons.expiry': 'Vencimiento',
    'coupons.save': 'Guardar',
    'sidebar.notifications': 'Notificaciónes',
    'sidebar.verification': 'Verificaciónes',
    // Hero extras
    'landing.hero.searchPlaceholder': 'A donde queres viajar?',
    'landing.hero.secureBookings': 'Reservas y pagos seguros. {count}+ alojamientos verificados.',
    // Featured extras
    'landing.featured.from': 'Desde',
    'landing.featured.viewProperty': 'Ver alojamiento',
    'landing.featured.accommodation': 'Alojamiento',
    // Last minute offers
    'landing.offers.label': 'Ofertas de último momento',
    'landing.offers.title': 'Aprovecha estos precios especiales',
    'landing.offers.viewAll': 'Ver todas',
    // Testimonials extras
    'landing.testimonials.desc': 'Comentarios de viajeros que eligieron alojamientos gestionados por Estadía 365 y valoraron la atención, la ubicación y la calidad de su estadía.',
    // Newsletter
    'landing.newsletter.title': 'Recibi ofertas exclusivas',
    'landing.newsletter.desc': 'Suscribite al newsletter y enterate primero de las mejores ofertas y nuevos destinos',
    'landing.newsletter.subscribe': 'Suscribirme',
    'landing.newsletter.success': 'Suscripción exitosa',
    'landing.newsletter.already': 'Ya estas suscrito',
    'landing.newsletter.error': 'Error al suscribirse',
    'landing.newsletter.placeholder': 'Tu email',
    // Footer extras
    'landing.footer.accommodations': 'Alojamientos',
    'landing.footer.destinations': 'Destinos',
    'landing.footer.posts': 'Publicaciónes',
    'landing.footer.addProperty': 'Sumar mi alojamiento',
    'landing.footer.termsConditions': 'Terminos y condiciones',
    'landing.footer.privacyPolicy': 'Política de privacidad',
    // Popup
    'popup.title': 'Tenes un alojamiento para sumar?',
    'popup.desc': 'En Estadía 365 te ayudamos a ganar visibilidad, recibir mas consultas y convertir tu espacio en nuevas oportunidades de reserva.',
    'popup.types': 'Hoteles, cabañas, departamentos, casas privadas y alojamientos turisticos.',
    'popup.faq': 'Ver Preguntas Frecuentes',
    'popup.whatsapp': 'Hablar por WhatsApp',
  },
  en: {
    'nav.properties': 'Properties',
    'nav.login': 'Sign In',
    'nav.dashboard': 'Admin Panel',
    'nav.logout': 'Sign Out',
    'nav.favorites': 'My Favorites',
    'nav.messages': 'Messages',
    'nav.verification': 'Verification',
    'nav.back': 'Back',
    'map.searchPlaceholder': 'Search property, city or code...',
    'map.filters': 'Filters',
    'map.properties': 'properties',
    'map.country': 'Country',
    'map.city': 'City',
    'map.guests': 'Guests',
    'map.bedrooms': 'Bedrooms',
    'map.all': 'All',
    'map.any': 'Any',
    'map.clearFilters': 'Clear',
    'map.viewProperty': 'View',
    'landing.viewMap': 'Explore Map',
    'properties.viewMap': 'View Map',
    'landing.hero.subtitle': 'Accommodations in Paraguay, Argentina and Brazil',
    'landing.hero.title': 'Discover your next destination',
    'landing.hero.desc': 'Over {properties} unique properties in {cities} cities in Paraguay. From boutique hotels to cabins surrounded by nature.',
    'landing.search.placeholder': 'Where are you going?',
    'landing.search.button': 'Search',
    'landing.why.label': 'Why choose us',
    'landing.why.title': 'The best accommodation experience',
    'landing.why.properties': '+{count} Properties',
    'landing.why.properties.desc': 'Wide variety of verified accommodations in Paraguay, Argentina and Brazil',
    'landing.why.payments': 'Multi-Currency Payments',
    'landing.why.payments.desc': 'Accept USD, PYG, ARS, BRL and more with updated exchange rates',
    'landing.why.security': 'Secure Bookings',
    'landing.why.security.desc': 'Reliable booking process with instant confirmation',
    'landing.why.support': 'Fast Support',
    'landing.why.support.desc': 'We help you find the ideal option for your trip with personalized assistance.',
    'landing.why.protection': 'Protected Booking',
    'landing.why.protection.desc': 'Secure payment, support for any issues, and peace of mind throughout the process.',
    'landing.destinations': 'Destinations',
    'landing.destinations.title': 'Explore our countries',
    'landing.destinations.explore': 'Explore',
    'landing.destinations.properties': 'properties',
    'landing.featured': 'Featured',
    'landing.featured.title': 'Popular properties',
    'landing.featured.viewAll': 'View all',
    'landing.featured.viewAllMobile': 'View all properties',
    'landing.testimonials': 'Testimonials',
    'landing.testimonials.title': 'What our guests say',
    'landing.cta.title': 'Own a property?',
    'landing.cta.subtitle': 'Join our platform and reach thousands of travelers. Manage your bookings, sync with Airbnb and receive payments in multiple currencies.',
    'landing.cta.button': 'List my property',
    'landing.instagram.follow': 'Follow us on',
    'landing.instagram.view': 'View Instagram',
    'landing.footer.desc': 'The leading accommodation platform in Paraguay, Brazil and Argentina with multi-currency payments and Airbnb sync.',
    'landing.footer.links': 'Links',
    'landing.footer.aboutUs': 'About us',
    'landing.footer.contact': 'Contact',
    'landing.footer.legal': 'Legal',
    'landing.footer.terms': 'Terms',
    'landing.footer.privacy': 'Privacy',
    'landing.footer.rights': '2026 Estadía 365. All rights reserved.',
    'landing.coupon.use': 'Use',
    'landing.coupon.get': 'and get',
    'landing.coupon.off': 'off',
    'common.guests': 'guests',
    'common.perNight': '/ night',
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.save': 'Save',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.close': 'Close',
    'common.confirm': 'Confirm',
    'common.added': 'Added to favorites',
    'common.removed': 'Removed from favorites',
    'common.loginRequired': 'Sign in to continue',
    'properties.title': 'Properties',
    'properties.subtitle': '{count} accommodations available',
    'properties.search.placeholder': 'Search by name, code...',
    'properties.search.button': 'Search',
    'properties.filter.clear': 'Clear',
    'properties.filter.country': 'Country',
    'properties.filter.city': 'City',
    'properties.filter.type': 'Type',
    'properties.filter.priceMin': 'Min price',
    'properties.filter.priceMax': 'Max price',
    'properties.filter.bedrooms': 'Bedrooms',
    'properties.filter.guests': 'Guests',
    'properties.filter.sortBy': 'Sort by',
    'properties.filter.all': 'All',
    'properties.filter.allCities': 'All',
    'properties.filter.mostRecent': 'Most recent',
    'properties.filter.priceAsc': 'Price: low to high',
    'properties.filter.priceDesc': 'Price: high to low',
    'properties.filter.moreGuests': 'Most guests',
    'properties.noResults': 'No properties found',
    'properties.noResults.desc': 'Try different filters',
    'properties.instantBooking': 'Instant Booking',
    'type.Hotel': 'Hotel',
    'type.Apartment': 'Apartment',
    'type.House': 'House',
    'type.Cabin': 'Cabin',
    'detail.back': 'Back',
    'detail.guests': 'Guests',
    'detail.bedrooms': 'Bedrooms',
    'detail.beds': 'Beds',
    'detail.bathrooms': 'Bathrooms',
    'detail.description': 'Description',
    'detail.amenities': 'Amenities',
    'detail.location': 'Location',
    'detail.viewMaps': 'View on Google Maps',
    'detail.cancellation': 'Cancellation Policy',
    'detail.cancellation.flexible': 'Flexible',
    'detail.cancellation.flexible.desc': 'Full refund if you cancel up to 24 hours before check-in.',
    'detail.cancellation.moderate': 'Moderate',
    'detail.cancellation.moderate.desc': 'Full refund if you cancel up to 5 days before check-in.',
    'detail.cancellation.strict': 'Strict',
    'detail.cancellation.strict.desc': '50% refund if you cancel up to 7 days before check-in. No refund after.',
    'detail.cancellation.non_refundable': 'Non-refundable',
    'detail.cancellation.non_refundable.desc': 'This booking is non-refundable once confirmed.',
    'detail.checkin': 'Check-in / Check-out',
    'detail.checkinTime': 'Check-in',
    'detail.checkinFrom': 'From',
    'detail.checkoutTime': 'Check-out',
    'detail.checkoutBefore': 'Before',
    'detail.accessCode': 'Access code',
    'detail.checkinInstructions': 'Arrival instructions',
    'detail.checkoutInstructions': 'Departure instructions',
    'detail.houseRules': 'House Rules',
    'detail.policies': 'Guest Policies',
    'detail.petsAllowed': 'Pets',
    'detail.childrenAllowed': 'Children',
    'detail.infantsAllowed': 'Infants',
    'detail.smokingAllowed': 'Smoking',
    'detail.minNights': 'Minimum',
    'detail.maxNights': 'Maximum',
    'detail.reviews': 'Reviews',
    'detail.writeReview': 'Write Review',
    'detail.noReviews': 'No reviews yet for this property',
    'detail.beFirst': 'Be the first to leave one!',
    'detail.ownerResponse': 'Owner response',
    'detail.respond': 'Respond',
    'detail.cancel': 'Cancel',
    'detail.booking': 'Book',
    'detail.selectDates': 'Select your dates',
    'detail.checkIn': 'Check-in',
    'detail.checkOut': 'Check-out',
    'detail.night': 'night',
    'detail.nights': 'nights',
    'detail.total': 'Total',
    'detail.cleaning': 'Cleaning',
    'detail.adults': 'Adults',
    'detail.age13plus': '13 years or older',
    'detail.children': 'Children',
    'detail.age2to12': '2 to 12 years',
    'detail.infants': 'Infants',
    'detail.under2': 'Under 2 years',
    'detail.maxGuests': 'Maximum',
    'detail.guestsLabel': 'guests',
    'detail.infantsNotCount': 'infants don\'t count',
    'detail.deposit': 'Total to pay',
    'detail.depositFinal': 'Final total',
    'detail.payDeposit': 'Pay Deposit',
    'detail.processing': 'Processing...',
    'detail.viewAirbnb': 'View on Airbnb',
    'detail.contactOwner': 'Contact owner',
    'detail.adminContact': 'Admin contact',
    'detail.whatsapp': 'WhatsApp',
    'detail.notAvailable': 'Not available',
    'detail.includesAirbnb': '(Includes Airbnb)',
    'detail.coupon': 'Discount coupon',
    'detail.couponPlaceholder': 'Coupon code',
    'detail.applyCoupon': 'Apply',
    'detail.couponApplied': 'Coupon applied',
    'detail.discount': 'Discount',
    'detail.depositAfterDiscount': 'Total with discount',
    'review.title': 'Write Review',
    'review.overall': 'Overall Rating',
    'review.categories': 'Categories',
    'review.cleanliness': 'Cleanliness',
    'review.location': 'Location',
    'review.service': 'Service',
    'review.value': 'Value for Money',
    'review.amenities': 'Amenities',
    'review.comment': 'Comment',
    'review.commentPlaceholder': 'Share your experience... (min 10 characters)',
    'review.photos': 'Photos (optional)',
    'review.photosCount': '{count}/5 photos',
    'review.addPhoto': 'Add',
    'review.publish': 'Publish Review',
    'review.publishing': 'Publishing...',
    'payment.bankTransfer': 'Bank Transfer',
    'payment.howToPay': 'How to pay by transfer',
    'payment.scanQR': 'Scan the QR or use bank details',
    'payment.alias': 'Alias',
    'payment.copied': 'Copied!',
    'wishlist.title': 'My Favorites',
    'wishlist.count': '{count} properties',
    'wishlist.empty.title': 'Your wishlist is empty',
    'wishlist.empty.desc': 'Explore properties and save the ones you like',
    'wishlist.empty.explore': 'Explore properties',
    'sidebar.dashboard': 'Dashboard',
    'sidebar.properties': 'Properties',
    'sidebar.favorites': 'Favorites',
    'sidebar.reservations': 'Reservations',
    'sidebar.calendar': 'Calendar',
    'sidebar.chat': 'Chat',
    'sidebar.reports': 'Reports',
    'sidebar.settings': 'Settings',
    'sidebar.users': 'Users',
    'sidebar.coupons': 'Coupons',
    'coupons.title': 'Coupons',
    'coupons.create': 'Create Coupon',
    'coupons.active': 'Active',
    'coupons.inactive': 'Inactive',
    'coupons.used': 'Uses',
    'coupons.code': 'Code',
    'coupons.type': 'Type',
    'coupons.percentage': 'Percentage',
    'coupons.fixed': 'Fixed amount',
    'coupons.value': 'Value',
    'coupons.maxUses': 'Max uses',
    'coupons.minAmount': 'Min amount',
    'coupons.expiry': 'Expiry',
    'coupons.save': 'Save',
    'sidebar.notifications': 'Notifications',
    'sidebar.verification': 'Verifications',
    // Hero extras
    'landing.hero.searchPlaceholder': 'Where do you want to travel?',
    'landing.hero.secureBookings': 'Secure bookings and payments. {count}+ verified accommodations.',
    // Featured extras
    'landing.featured.from': 'From',
    'landing.featured.viewProperty': 'View property',
    'landing.featured.accommodation': 'Accommodation',
    // Last minute offers
    'landing.offers.label': 'Last minute deals',
    'landing.offers.title': 'Take advantage of these special prices',
    'landing.offers.viewAll': 'View all',
    // Testimonials extras
    'landing.testimonials.desc': 'Reviews from travelers who chose accommodations managed by Estadía 365 and valued the attention, location and quality of their stay.',
    // Newsletter
    'landing.newsletter.title': 'Get exclusive deals',
    'landing.newsletter.desc': 'Subscribe to our newsletter and be the first to know about the best offers and new destinations',
    'landing.newsletter.subscribe': 'Subscribe',
    'landing.newsletter.success': 'Successfully subscribed',
    'landing.newsletter.already': 'Already subscribed',
    'landing.newsletter.error': 'Error subscribing',
    'landing.newsletter.placeholder': 'Your email',
    // Footer extras
    'landing.footer.accommodations': 'Accommodations',
    'landing.footer.destinations': 'Destinations',
    'landing.footer.posts': 'Blog',
    'landing.footer.addProperty': 'List my property',
    'landing.footer.termsConditions': 'Terms and conditions',
    'landing.footer.privacyPolicy': 'Privacy policy',
    // Popup
    'popup.title': 'Have a property to list?',
    'popup.desc': 'At Estadía 365 we help you gain visibility, receive more inquiries and turn your space into new booking opportunities.',
    'popup.types': 'Hotels, cabins, apartments, private houses and tourist accommodations.',
    'popup.faq': 'View FAQ',
    'popup.whatsapp': 'Chat on WhatsApp',
  },
  pt: {
    'nav.properties': 'Propriedades',
    'nav.login': 'Entrar',
    'nav.dashboard': 'Painel Admin',
    'nav.logout': 'Sair',
    'nav.favorites': 'Meus Favoritos',
    'nav.messages': 'Mensagens',
    'nav.verification': 'Verificacao',
    'nav.back': 'Voltar',
    'map.searchPlaceholder': 'Buscar propriedade, cidade ou código...',
    'map.filters': 'Filtros',
    'map.properties': 'propriedades',
    'map.country': 'Pais',
    'map.city': 'Cidade',
    'map.guests': 'Hospedes',
    'map.bedrooms': 'Quartos',
    'map.all': 'Todos',
    'map.any': 'Qualquer',
    'map.clearFilters': 'Limpar',
    'map.viewProperty': 'Ver',
    'landing.viewMap': 'Explorar Mapa',
    'properties.viewMap': 'Ver Mapa',
    'landing.hero.subtitle': 'Hospedagens no Paraguai, Argentina e Brasil',
    'landing.hero.title': 'Descubra seu próximo destino',
    'landing.hero.desc': 'Mais de {properties} propriedades unicas em {cities} cidades do Paraguai. De hoteis boutique a cabañas cercadas pela natureza.',
    'landing.search.placeholder': 'Para onde voce vai?',
    'landing.search.button': 'Buscar',
    'landing.why.label': 'Por que nos escolher',
    'landing.why.title': 'A melhor experiencia de hospedagem',
    'landing.why.properties': '+{count} Propriedades',
    'landing.why.properties.desc': 'Grande variedade de hospedagens verificadas no Paraguai, Argentina e Brasil',
    'landing.why.payments': 'Pagamentos Múltimoeda',
    'landing.why.payments.desc': 'Aceita USD, PYG, ARS, BRL e mais com taxas de cambio atualizadas',
    'landing.why.security': 'Reservas Seguras',
    'landing.why.security.desc': 'Processo de reserva confiavel com confirmacao instantanea',
    'landing.why.support': 'Atendimento rapido',
    'landing.why.support.desc': 'Ajudamos voce a encontrar a opcao ideal para sua viagem com acompanhamento personalizado.',
    'landing.why.protection': 'Reserva protegida',
    'landing.why.protection.desc': 'Pagamento seguro, suporte em caso de problemas e mais tranquilidade durante todo o processo.',
    'landing.destinations': 'Destinos',
    'landing.destinations.title': 'Explore nossos paises',
    'landing.destinations.explore': 'Explorar',
    'landing.destinations.properties': 'propriedades',
    'landing.featured': 'Destaques',
    'landing.featured.title': 'Propriedades populares',
    'landing.featured.viewAll': 'Ver todas',
    'landing.featured.viewAllMobile': 'Ver todas as propriedades',
    'landing.testimonials': 'Depoimentos',
    'landing.testimonials.title': 'O que dizem nossos hospedes',
    'landing.cta.title': 'Tem uma propriedade?',
    'landing.cta.subtitle': 'Junte-se a nossa plataforma e alcance milhares de viajantes. Gerencie suas reservas, sincronize com o Airbnb e receba pagamentos em varias moedas.',
    'landing.cta.button': 'Cadastrar minha propriedade',
    'landing.instagram.follow': 'Siga-nos no',
    'landing.instagram.view': 'Ver Instagram',
    'landing.footer.desc': 'A plataforma lider de hospedagens no Paraguai, Brasil e Argentina com pagamentos múltimoeda e sincronizacao com o Airbnb.',
    'landing.footer.links': 'Links',
    'landing.footer.aboutUs': 'Sobre nos',
    'landing.footer.contact': 'Contato',
    'landing.footer.legal': 'Legal',
    'landing.footer.terms': 'Termos',
    'landing.footer.privacy': 'Privacidade',
    'landing.footer.rights': '2026 Estadia 365. Todos os direitos reservados.',
    'landing.coupon.use': 'Use',
    'landing.coupon.get': 'e ganhe',
    'landing.coupon.off': 'de desconto',
    'common.guests': 'hospedes',
    'common.perNight': '/ noite',
    'common.loading': 'Carregando...',
    'common.error': 'Erro',
    'common.save': 'Salvar',
    'common.delete': 'Excluir',
    'common.edit': 'Editar',
    'common.close': 'Fechar',
    'common.confirm': 'Confirmar',
    'common.added': 'Adicionado aos favoritos',
    'common.removed': 'Removido dos favoritos',
    'common.loginRequired': 'Entre para continuar',
    'properties.title': 'Propriedades',
    'properties.subtitle': '{count} hospedagens disponiveis',
    'properties.search.placeholder': 'Buscar por nome, código...',
    'properties.search.button': 'Buscar',
    'properties.filter.clear': 'Limpar',
    'properties.filter.country': 'Pais',
    'properties.filter.city': 'Cidade',
    'properties.filter.type': 'Tipo',
    'properties.filter.priceMin': 'Preco min',
    'properties.filter.priceMax': 'Preco max',
    'properties.filter.bedrooms': 'Quartos',
    'properties.filter.guests': 'Hospedes',
    'properties.filter.sortBy': 'Ordenar por',
    'properties.filter.all': 'Todos',
    'properties.filter.allCities': 'Todas',
    'properties.filter.mostRecent': 'Mais recentes',
    'properties.filter.priceAsc': 'Preco: menor para maior',
    'properties.filter.priceDesc': 'Preco: maior para menor',
    'properties.filter.moreGuests': 'Mais hospedes',
    'properties.noResults': 'Nenhuma propriedade encontrada',
    'properties.noResults.desc': 'Tente filtros diferentes',
    'properties.instantBooking': 'Reserva Imediata',
    'type.Hotel': 'Hotel',
    'type.Apartment': 'Apartamento',
    'type.House': 'Casa',
    'type.Cabin': 'Cabaña',
    'detail.back': 'Voltar',
    'detail.guests': 'Hospedes',
    'detail.bedrooms': 'Quartos',
    'detail.beds': 'Camas',
    'detail.bathrooms': 'Banheiros',
    'detail.description': 'Descricao',
    'detail.amenities': 'Comodidades',
    'detail.location': 'Localizacao',
    'detail.viewMaps': 'Ver no Google Maps',
    'detail.cancellation': 'Política de Cancelamento',
    'detail.cancellation.flexible': 'Flexivel',
    'detail.cancellation.flexible.desc': 'Reembolso total se cancelar ate 24 horas antes do check-in.',
    'detail.cancellation.moderate': 'Moderada',
    'detail.cancellation.moderate.desc': 'Reembolso total se cancelar ate 5 dias antes do check-in.',
    'detail.cancellation.strict': 'Estrita',
    'detail.cancellation.strict.desc': '50% de reembolso se cancelar ate 7 dias antes do check-in. Sem reembolso depois.',
    'detail.cancellation.non_refundable': 'Nao reembolsavel',
    'detail.cancellation.non_refundable.desc': 'Esta reserva nao e reembolsavel apos confirmada.',
    'detail.checkin': 'Check-in / Check-out',
    'detail.checkinTime': 'Check-in',
    'detail.checkinFrom': 'A partir das',
    'detail.checkoutTime': 'Check-out',
    'detail.checkoutBefore': 'Antes das',
    'detail.accessCode': 'Código de acesso',
    'detail.checkinInstructions': 'Instrucoes de chegada',
    'detail.checkoutInstructions': 'Instrucoes de saida',
    'detail.houseRules': 'Regras da Casa',
    'detail.policies': 'Políticas de Hospedes',
    'detail.petsAllowed': 'Animais',
    'detail.childrenAllowed': 'Criancas',
    'detail.infantsAllowed': 'Bebés',
    'detail.smokingAllowed': 'Fumar',
    'detail.minNights': 'Mínimo',
    'detail.maxNights': 'Máximo',
    'detail.reviews': 'Avaliacoes',
    'detail.writeReview': 'Escrever Avaliacao',
    'detail.noReviews': 'Ainda nao ha avaliacoes para esta propriedade',
    'detail.beFirst': 'Seja o primeiro a avaliar!',
    'detail.ownerResponse': 'Resposta do proprietario',
    'detail.respond': 'Responder',
    'detail.cancel': 'Cancelar',
    'detail.booking': 'Reservar',
    'detail.selectDates': 'Selecione suas datas',
    'detail.checkIn': 'Check-in',
    'detail.checkOut': 'Check-out',
    'detail.nights': 'noites',
    'detail.total': 'Total',
    'detail.cleaning': 'Limpeza',
    'detail.adults': 'Adultos',
    'detail.age13plus': '13 anos ou mais',
    'detail.children': 'Criancas',
    'detail.age2to12': '2 a 12 años',
    'detail.infants': 'Bebés',
    'detail.under2': 'Menos de 2 años',
    'detail.maxGuests': 'Máximo',
    'detail.guestsLabel': 'hospedes',
    'detail.infantsNotCount': 'bebes nao contam',
    'detail.deposit': 'Total a pagar',
    'detail.depositFinal': 'Total final',
    'detail.payDeposit': 'Pagar Deposito',
    'detail.processing': 'Processando...',
    'detail.viewAirbnb': 'Ver no Airbnb',
    'detail.contactOwner': 'Contatar proprietario',
    'detail.adminContact': 'Contato do administrador',
    'detail.whatsapp': 'WhatsApp',
    'detail.notAvailable': 'Nao disponivel',
    'detail.includesAirbnb': '(Inclui Airbnb)',
    'detail.coupon': 'Cupom de desconto',
    'detail.couponPlaceholder': 'Código do cupom',
    'detail.applyCoupon': 'Aplicar',
    'detail.couponApplied': 'Cupom aplicado',
    'detail.discount': 'Desconto',
    'detail.depositAfterDiscount': 'Total com desconto',
    'review.title': 'Escrever Avaliacao',
    'review.overall': 'Avaliacao Geral',
    'review.categories': 'Categorias',
    'review.cleanliness': 'Limpeza',
    'review.location': 'Localizacao',
    'review.service': 'Servico',
    'review.value': 'Custo-Beneficio',
    'review.amenities': 'Comodidades',
    'review.comment': 'Comentario',
    'review.commentPlaceholder': 'Compartilhe sua experiencia... (mínimo 10 caracteres)',
    'review.photos': 'Fotos (opcional)',
    'review.photosCount': '{count}/5 fotos',
    'review.addPhoto': 'Adicionar',
    'review.publish': 'Publicar Avaliacao',
    'review.publishing': 'Publicando...',
    'payment.bankTransfer': 'Transferencia Bancaria',
    'payment.howToPay': 'Como pagar por transferencia',
    'payment.scanQR': 'Escaneie o QR ou use os dados bancarios',
    'payment.alias': 'Alias',
    'payment.copied': 'Copiado!',
    'wishlist.title': 'Meus Favoritos',
    'wishlist.count': '{count} propriedades',
    'wishlist.empty.title': 'Sua lista de favoritos esta vazia',
    'wishlist.empty.desc': 'Explore propriedades e salve as que mais gostar',
    'wishlist.empty.explore': 'Explorar propriedades',
    'sidebar.dashboard': 'Painel',
    'sidebar.properties': 'Propriedades',
    'sidebar.favorites': 'Favoritos',
    'sidebar.reservations': 'Reservas',
    'sidebar.calendar': 'Calendario',
    'sidebar.chat': 'Chat',
    'sidebar.reports': 'Relatorios',
    'sidebar.settings': 'Configuracoes',
    'sidebar.users': 'Usuarios',
    'sidebar.coupons': 'Cupóns',
    'coupons.title': 'Cupóns',
    'coupons.create': 'Criar Cupom',
    'coupons.active': 'Ativo',
    'coupons.inactive': 'Inativo',
    'coupons.used': 'Usos',
    'coupons.code': 'Código',
    'coupons.type': 'Tipo',
    'coupons.percentage': 'Porcentagem',
    'coupons.fixed': 'Valor fixo',
    'coupons.value': 'Valor',
    'coupons.maxUses': 'Usos máximos',
    'coupons.minAmount': 'Valor mínimo',
    'coupons.expiry': 'Vencimento',
    'coupons.save': 'Salvar',
    'sidebar.notifications': 'Notificacoes',
    'sidebar.verification': 'Verificacoes',
    // Hero extras
    'landing.hero.searchPlaceholder': 'Para onde voce quer viajar?',
    'landing.hero.secureBookings': 'Reservas e pagamentos seguros. {count}+ hospedagens verificadas.',
    // Featured extras
    'landing.featured.from': 'A partir de',
    'landing.featured.viewProperty': 'Ver propriedade',
    'landing.featured.accommodation': 'Hospedagem',
    // Last minute offers
    'landing.offers.label': 'Ofertas de ultima hora',
    'landing.offers.title': 'Aproveite estes precos especiais',
    'landing.offers.viewAll': 'Ver todas',
    // Testimonials extras
    'landing.testimonials.desc': 'Comentarios de viajantes que escolheram hospedagens gerenciadas pela Estadía 365 e valorizaram a atencao, a localizacao e a qualidade de sua estadia.',
    // Newsletter
    'landing.newsletter.title': 'Receba ofertas exclusivas',
    'landing.newsletter.desc': 'Inscreva-se na newsletter e fique sabendo primeiro das melhores ofertas e novos destinos',
    'landing.newsletter.subscribe': 'Inscrever-me',
    'landing.newsletter.success': 'Inscricao realizada',
    'landing.newsletter.already': 'Ja esta inscrito',
    'landing.newsletter.error': 'Erro ao inscrever',
    'landing.newsletter.placeholder': 'Seu email',
    // Footer extras
    'landing.footer.accommodations': 'Hospedagens',
    'landing.footer.destinations': 'Destinos',
    'landing.footer.posts': 'Publicacoes',
    'landing.footer.addProperty': 'Adicionar minha propriedade',
    'landing.footer.termsConditions': 'Termos e condicoes',
    'landing.footer.privacyPolicy': 'Política de privacidade',
    // Popup
    'popup.title': 'Tem uma propriedade para adicionar?',
    'popup.desc': 'Na Estadía 365 ajudamos voce a ganhar visibilidade, receber mais consultas e transformar seu espaco em novas oportunidades de reserva.',
    'popup.types': 'Hoteis, cabañas, apartamentos, casas particulares e hospedagens turisticas.',
    'popup.faq': 'Ver Perguntas Frequentes',
    'popup.whatsapp': 'Falar pelo WhatsApp',
  }
};

const I18nContext = createContext(null);

export const useI18n = () => useContext(I18nContext);

export const I18nProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => {
    return localStorage.getItem('estadia_locale') || 'es';
  });

  const [currency, setCurrency] = useState(() => {
    return localStorage.getItem('estadia_currency') || 'USD';
  });

  const [exchangeRates, setExchangeRates] = useState({});

  const changeCurrency = useCallback((newCurrency) => {
    setCurrency(newCurrency);
    localStorage.setItem('estadia_currency', newCurrency);
  }, []);

  const changeLocale = useCallback((newLocale) => {
    setLocale(newLocale);
    localStorage.setItem('estadia_locale', newLocale);
  }, []);

  const t = useCallback((key, params = {}) => {
    let text = translations[locale]?.[key] || translations['es']?.[key] || key;
    Object.entries(params).forEach(([k, v]) => {
      text = text.replace(`{${k}}`, v);
    });
    return text;
  }, [locale]);

  const formatPrice = useCallback((usdAmount) => {
    if (!usdAmount || isNaN(usdAmount)) return 'USD 0';
    const amount = parseFloat(usdAmount);
    if (currency === 'USD') return `USD ${amount.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    const rate = exchangeRates[currency];
    if (!rate) return `USD ${amount.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    const converted = amount * rate;
    const symbols = { PYG: 'Gs.', ARS: 'AR$', BRL: 'R$' };
    const symbol = symbols[currency] || currency;
    if (currency === 'PYG') return `${symbol} ${Math.round(converted).toLocaleString('es')}`;
    return `${symbol} ${converted.toLocaleString('es', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  }, [currency, exchangeRates]);

  const convertToUsd = useCallback((amount) => {
    if (!amount || isNaN(amount)) return 0;
    const val = parseFloat(amount);
    if (currency === 'USD') return val;
    const rate = exchangeRates[currency];
    if (!rate || rate === 0) return val;
    return val / rate;
  }, [currency, exchangeRates]);

  const convertFromUsd = useCallback((usdAmount) => {
    if (!usdAmount || isNaN(usdAmount)) return 0;
    const val = parseFloat(usdAmount);
    if (currency === 'USD') return val;
    const rate = exchangeRates[currency];
    if (!rate) return val;
    return val * rate;
  }, [currency, exchangeRates]);

  const currencySymbol = useCallback(() => {
    const symbols = { USD: 'USD', PYG: 'Gs.', ARS: 'AR$', BRL: 'R$' };
    return symbols[currency] || currency;
  }, [currency]);

  return (
    <I18nContext.Provider value={{ locale, setLocale: changeLocale, t, currency, setCurrency: changeCurrency, exchangeRates, setExchangeRates, formatPrice, convertToUsd, convertFromUsd, currencySymbol }}>
      {children}
    </I18nContext.Provider>
  );
};

export const LOCALES = [
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'pt', label: 'Portugues', flag: '🇧🇷' }
];

export const CURRENCIES = [
  { code: 'USD', symbol: 'USD', label: 'USD' },
  { code: 'PYG', symbol: 'Gs.', label: 'PYG' },
  { code: 'ARS', symbol: 'AR$', label: 'ARS' },
  { code: 'BRL', symbol: 'R$', label: 'BRL' }
];
